import { EmpresaService } from './src/services/empresas.services';

export type { Empresa, UsuarioEmpresa, EmpresaProducto, EmpresaRedSocial } from './src/services/suite.interfaces';

export const empresaService = new EmpresaService();

export default empresaService;
